import React, { useState } from "react";
import Grid from "styled-components-grid";
import Input from "../UI/Form/Input";
import styled from "styled-components";
import SelectUI from "../UI/Form/SelectUI";
import { AiOutlineCloudUpload } from "react-icons/ai";

const Swatch = styled.div`
  width: 50px;
  height: 30px;
  border: 1px solid grey;
  border-radius: 3px;
  margin: 0.5em;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  display: flex;
  overflow: hidden;
`;
const ColourContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;
export default function OfficialsEdit({ officials, onChange }) {
  function updateOfficials(officials) {
    onChange(officials);
  }

  return (
    <Grid style={{ width: "100%" }}>
      <Grid.Unit size={1 / 1}>
        <Input
          value={officials.first_name}
          title="First Name"
          onChange={(e) => {
            let newOfficials = { ...officials, first_name: e.target.value };
            updateOfficials(newOfficials);
          }}
        />
        <Input
          value={officials.last_name}
          title="Last Name"
          onChange={(e) => {
            let newOfficials = { ...officials, last_name: e.target.value };
            updateOfficials(newOfficials);
          }}
        />
        <Input
          value={officials.nation}
          title="Nationality"
          onChange={(e) => {
            let newOfficials = { ...officials, nation: e.target.value };
            updateOfficials(newOfficials);
          }}
        />
      </Grid.Unit>
    </Grid>
  );
}
